export const SAVE_SEARCH_BUTTON_CLICK_EVENT = 'saveSearchButton:clicked';

export const dispatchSaveSearchButtonClickEvent = () => {
  dispatchEvent(new CustomEvent(SAVE_SEARCH_BUTTON_CLICK_EVENT));
};
